import { PropTypes } from "aem/ComponentWrapper";
import React from "react";

export default {
  title: "Menu Link List",
  type: "rh/components/content/menulinklist",
  isContainer: false,
  config: {
    emptyLabel: "Menu Link List",
    isEmpty: ({ children }: PropTypes) => React.Children.count(children) === 0
  }
};
